<form [formGroup]="searchForm">
  <mat-form-field>
    <mat-label>{{ titleSearch }}</mat-label>
    <input type="text" formControlName="content" matInput maxlength="500" />
  </mat-form-field>

  <mat-radio-group formControlName="type">
    <mat-radio-button value="ALL">Todos</mat-radio-button>
    <mat-radio-button value="READ">{{
      "label-read" | translate
    }}</mat-radio-button>
    <mat-radio-button value="UNREAD">{{
      "label-unread" | translate
    }}</mat-radio-button>
  </mat-radio-group>
</form>

<hr />

<div
  class="alerts-list mt-3"
  *ngIf="arrayAccordion && filteredArray.length === 0; else filtered"
>
  <mat-accordion
    style="width: 100%"
    *ngIf="
      arrayAccordion.today ||
      arrayAccordion.yesterday ||
      arrayAccordion.week ||
      arrayAccordion.older
    "
  >
    <mat-expansion-panel
      (opened)="panelOpenStateToday = true"
      (closed)="panelOpenStateToday = false"
      hideToggle
      *ngIf="arrayAccordion.today.length > 0"
    >
      <mat-expansion-panel-header collapsedHeight="30px" expandedHeight="30px">
        <mat-icon
          fontIcon="bosch-ic-down"
          *ngIf="panelOpenStateToday === false"
        ></mat-icon>
        <mat-icon
          fontIcon="bosch-ic-up"
          *ngIf="panelOpenStateToday === true"
        ></mat-icon>
        <mat-panel-title
          style="font-size: 16px; font-family: Bosch-Sans, serif"
        >
          {{ "alert-today" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="row message-thumbnail"
        *ngFor="let currentAlert of arrayAccordion.today"
      >
        <div class="col-1 align-horizontal-and-vertical-center">
          <div
            class="unread"
            [id]="currentAlert.id"
            *ngIf="currentAlert.readStatus !== 'READ'; else read"
          ></div>
          <ng-template #read>
            <div class="read" [id]="currentAlert.id"></div>
          </ng-template>
        </div>
        <div (click)="setAlert(currentAlert)" class="col-10 alert-cursor">
          <div class="row alert-subject">
            <p>{{ currentAlert.alertSubject }}</p>
          </div>
          <div
            class="row alert-thumbnail"
            *ngIf="currentAlert.contentType === 'text'; else html"
          >
            <p>
              {{
                helperService.returnNFirstChars(currentAlert.alertMessage, 30)
              }}
            </p>
          </div>
          <ng-template #html>
            <div class="row alert-thumbnail">
              <p [innerHTML]="currentAlert.alertMessage"></p>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenStateYestarday = true"
      (closed)="panelOpenStateYestarday = false"
      hideToggle
      *ngIf="arrayAccordion.yesterday.length > 0"
    >
      <mat-expansion-panel-header collapsedHeight="30px" expandedHeight="30px">
        <mat-icon
          fontIcon="bosch-ic-down"
          *ngIf="panelOpenStateYestarday === false"
        ></mat-icon>
        <mat-icon
          fontIcon="bosch-ic-up"
          *ngIf="panelOpenStateYestarday === true"
        ></mat-icon>
        <mat-panel-title
          style="font-size: 16px; font-family: Bosch-Sans, serif"
        >
          {{ "alert-yesterday" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="row message-thumbnail"
        *ngFor="let currentAlert of arrayAccordion.yesterday"
      >
        <div class="col-1 align-horizontal-and-vertical-center">
          <div
            class="unread"
            [id]="currentAlert.id"
            *ngIf="currentAlert.readStatus !== 'READ'; else read"
          ></div>
          <ng-template #read>
            <div class="read" [id]="currentAlert.id"></div>
          </ng-template>
        </div>
        <div (click)="setAlert(currentAlert)" class="col-10 alert-cursor">
          <div class="row alert-subject">
            <p>{{ currentAlert.alertSubject }}</p>
          </div>
          <div
            class="row alert-thumbnail"
            *ngIf="currentAlert.contentType === 'text'; else html"
          >
            <p>
              {{
                helperService.returnNFirstChars(currentAlert.alertMessage, 30)
              }}
            </p>
          </div>
          <ng-template #html>
            <div class="container">
              <div class="row alert-thumbnail">
                <div class="col-12">
                  <p [innerHTML]="currentAlert.alertMessage"></p>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenStateWeek = true"
      (closed)="panelOpenStateWeek = false"
      hideToggle
      *ngIf="arrayAccordion.week.length > 0"
    >
      <mat-expansion-panel-header collapsedHeight="30px" expandedHeight="30px">
        <mat-icon
          fontIcon="bosch-ic-down"
          *ngIf="panelOpenStateWeek === false"
        ></mat-icon>
        <mat-icon
          fontIcon="bosch-ic-up"
          *ngIf="panelOpenStateWeek === true"
        ></mat-icon>
        <mat-panel-title
          style="font-size: 16px; font-family: Bosch-Sans, serif"
        >
          {{ "alert-week" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="row message-thumbnail"
        *ngFor="let currentAlert of arrayAccordion.week"
      >
        <div class="col-1 align-horizontal-and-vertical-center">
          <div
            class="unread"
            [id]="currentAlert.id"
            *ngIf="currentAlert.readStatus !== 'READ'; else read"
          ></div>
          <ng-template #read>
            <div class="read" [id]="currentAlert.id"></div>
          </ng-template>
        </div>
        <div (click)="setAlert(currentAlert)" class="col-10 alert-cursor">
          <div class="row alert-subject">
            <p>{{ currentAlert.alertSubject }}</p>
          </div>
          <div
            class="row alert-thumbnail"
            *ngIf="currentAlert.contentType === 'text'; else html"
          >
            <p>
              {{
                helperService.returnNFirstChars(currentAlert.alertMessage, 30)
              }}
            </p>
          </div>
          <ng-template #html>
            <div class="row alert-thumbnail">
              <p [innerHTML]="currentAlert.alertMessage"></p>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel
      (opened)="panelOpenStateOlder = true"
      (closed)="panelOpenStateOlder = false"
      hideToggle
      *ngIf="arrayAccordion.older.length > 0"
    >
      <mat-expansion-panel-header collapsedHeight="30px" expandedHeight="30px">
        <mat-icon
          fontIcon="bosch-ic-down"
          *ngIf="panelOpenStateOlder === false"
        ></mat-icon>
        <mat-icon
          fontIcon="bosch-ic-up"
          *ngIf="panelOpenStateOlder === true"
        ></mat-icon>
        <mat-panel-title
          style="font-size: 16px; font-family: Bosch-Sans, serif"
        >
          {{ "alert-older" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div
        class="row message-thumbnail"
        *ngFor="let currentAlert of arrayAccordion.older"
      >
        <div class="col-1 align-horizontal-and-vertical-center">
          <div
            class="unread"
            [id]="currentAlert.id"
            *ngIf="currentAlert.readStatus !== 'READ'; else read"
          ></div>
          <ng-template #read>
            <div class="read" [id]="currentAlert.id"></div>
          </ng-template>
        </div>
        <div (click)="setAlert(currentAlert)" class="col-10 alert-cursor">
          <div class="row alert-subject">
            <p>{{ currentAlert.alertSubject }}</p>
          </div>
          <div
            class="row alert-thumbnail"
            *ngIf="currentAlert.contentType === 'text'; else html"
          >
            <p>
              {{
                helperService.returnNFirstChars(currentAlert.alertMessage, 30)
              }}
            </p>
          </div>
          <ng-template #html>
            <div class="row alert-thumbnail">
              <p [innerHTML]="currentAlert.alertMessage"></p>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>

<ng-template #filtered>
  <div class="row message-thumbnail" *ngFor="let currentAlert of filteredArray">
    <div class="col-1 align-horizontal-and-vertical-center">
      <div
        class="unread"
        [id]="currentAlert.id"
        *ngIf="currentAlert.readStatus !== 'READ'; else read"
      ></div>
      <ng-template #read>
        <div class="read" [id]="currentAlert.id"></div>
      </ng-template>
    </div>
    <div (click)="setAlert(currentAlert)" class="col-10 alert-cursor">
      <div class="row alert-subject">
        <p>
          <b>{{ currentAlert.alertSubject }}</b>
        </p>
      </div>
      <div class="row alert-thumbnail">
        <div
          [innerHTML]="
            helperService.highlightSearch(currentAlert.alertMessage, search)
          "
        ></div>
      </div>
    </div>
  </div>
</ng-template>
